import { Component, Prop } from 'vue-property-decorator';
import InputMixin from '@/mixins/inputMixins/base/InputMixin';

@Component
export default class NumberInputMixin extends InputMixin {
  @Prop({ default: undefined }) defaultValue: number | undefined;
}
